import React, { useEffect, useState, useCallback } from "react";
import _ from "lodash";
import {
    Grid,
    Box,
    TextField,
    Typography,
    Backdrop,
    CircularProgress,
    Pagination,
    Stack,
    Card
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import axios from "../../../../utils/fvAxios";
import Paginator from "../../../../toolkit/Paginator";

import Status from "../../../../stories/StatusComponent/StatusComponent";
import GetfVDateFormate from "../../../../utils/Genaricfunctions";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from "@mui/material/Tooltip";

export default function RenewalClientReview() {

    const pageSize = 12;
    const [vendorName, setVendorName] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [vendors, setVendors] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    const [searchDebounce, setSearchDebounce] = useState("");



    async function GetVendorsDetailsBasedOnClientReviewStatus() {
        try {
            document.activeElement?.blur();
            setLoading(true);
            const res = await axios.get(
                `Vendor/GetVendorsDetailsBasedOnClientReviewStatus?pageNumber=${pageNumber}&pageSize=${pageSize}&vendorName=${encodeURIComponent(searchDebounce)}&IsRenewal=true`
            );

            setVendors(res?.data?.data || []);
            setTotalRecords(res?.data?.count || 0);
        } catch (err) {
            console.log(err);
            setVendors([]);
        } finally {
            setLoading(false);
        }
    }

    const debouncedSearchHandler = useCallback(
        _.debounce((value) => {
            setSearchDebounce(value);
        }, 500),
        []
    );

    useEffect(() => {
        debouncedSearchHandler(vendorName);

        return () => {
            debouncedSearchHandler.cancel();
        };
    }, [vendorName, debouncedSearchHandler]);

    useEffect(() => {
        GetVendorsDetailsBasedOnClientReviewStatus();
    }, [searchDebounce, pageNumber]);

    const handleSearch = (value) => {
        handlePageChange(1);
        setVendorName(value);
    };

    const handlePageChange = (page) => {
        setPageNumber(page);
    };

    return (
        <Box >


            {/* <Backdrop
                open={loading}
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            >
                <CircularProgress color="inherit" />
            </Backdrop> */}



            <Card
                elevation={0}
                sx={{
                    p: 2,
                    border: "1px solid #E6EAF0",
                    borderRadius: "4px",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                    }}
                >
                    <TextField
                        size="small"
                        placeholder="Search vendor"
                        value={vendorName}
                        onChange={(e) => handleSearch(e.target.value)}
                        sx={{
                            width: {
                                xs: "100%",
                                sm: 320,
                                md: 360,
                            },
                            "& .MuiOutlinedInput-root": {
                                height: 42,
                                bgcolor: "#fff",
                            },
                        }}
                    />
                </Box>
            </Card>


            {/* Grid */}
            <Box>
                {loading ? (
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        height={300}
                    >
                        <CircularProgress />
                    </Box>
                ) : vendors.length > 0 ? (
                    <>
                        <Box
                            sx={{
                                backgroundColor: "#eaebee",
                                p: 2,
                            }}
                        >
                            <Grid container spacing={2}>
                                {vendors.map((item, index) => (
                                    <Grid
                                        item
                                        key={index}
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={3}
                                        xl={3}
                                        sx={{ display: "flex" }}
                                    >
                                        <Card
                                            elevation={0}
                                            sx={{
                                                width: "100%",
                                                minHeight: 160,
                                                border: "1px solid #E6EAF0",
                                                borderRadius: "2px",
                                                bgcolor: "#fff",
                                                p: 2,
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "space-between",
                                                transition: ".2s",
                                                "&:hover": {
                                                    boxShadow: "0 2px 10px rgba(0,0,0,.12)"
                                                }
                                            }}
                                        >
                                            <Box sx={{ height: "100%" }}>

                                                {/* Vendor Name */}
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "flex-start"
                                                    }}
                                                >
                                                    <Tooltip
                                                        title={item.vendorName}
                                                        placement="top"
                                                        arrow
                                                    >
                                                        <Typography
                                                            className="dashboardcontainer_ellipse"
                                                            sx={{
                                                                color: "#2A93DB",
                                                                fontSize: "18px",
                                                                fontWeight: 600,
                                                                lineHeight: 1.3,
                                                                cursor: "pointer",
                                                                width: "90%"
                                                            }}
                                                        >
                                                            <a
                                                                href={`/vendordetails?pqid=${item.prequalificationId}&ClientId=${item.clientId}`}
                                                                style={{
                                                                    color: "#2A93DB",
                                                                    textDecoration: "none"
                                                                }}
                                                            >
                                                                {item.vendorName}
                                                            </a>
                                                        </Typography>
                                                    </Tooltip>

                                                    {item?.isVendorRatingBelowThresholdLimit && (
                                                        <Tooltip
                                                            title={`User rating (${item.userRating}) is less than Threshold Limit`}
                                                            arrow
                                                        >
                                                            <InfoOutlinedIcon
                                                                sx={{
                                                                    color: "#d50000",
                                                                    fontSize: 22
                                                                }}
                                                            />
                                                        </Tooltip>
                                                    )}
                                                </Box>

                                                {/* Status Period */}
                                                <Box mt={1}>
                                                    <Typography>
                                                        Status Period:{" "}
                                                        {GetfVDateFormate(item.prequalificationStart)}
                                                        {" "}to{" "}
                                                        {GetfVDateFormate(item.prequalificationFinish)}
                                                    </Typography>
                                                </Box>

                                                {/* Risk Level */}
                                                <Box mt={1}>
                                                    <Typography >
                                                        Risk Level: {item.templateCode}
                                                    </Typography>
                                                </Box>

                                                {/* Status */}
                                                <Box
                                                    sx={{
                                                        mt: 1,
                                                        display: "flex",
                                                        alignItems: "flex-end"
                                                    }}
                                                >
                                                    <Status
                                                        typeStatus={item.Status || item.status}
                                                        ChangePq={true}
                                                    />
                                                </Box>

                                            </Box>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>

                        <div hidden={totalRecords == ""}>
                            <Paginator
                                count={Math.ceil(totalRecords / pageSize)}
                                page={Number(pageNumber)}
                                margin="18px 0px"
                                onChange={handlePageChange}
                            />
                        </div>

                    </>
                ) : (
                    !loading && (
                        <Card
                            elevation={0}
                            sx={{
                                width: "100%",
                                minHeight: "70px",
                                border: "1px solid #E6EAF0",
                                borderRadius: "4px",
                                backgroundColor: "#fff",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <Typography variant="h6" color="text.secondary">
                                No Data Found
                            </Typography>
                        </Card>
                    )
                )}
            </Box>

        </Box >
    );
}